/* Bee 3D — One-page Shop Builder (global script).
   Lives in assets/shop-builder.js, loaded from layout/theme.liquid, because
   Lumia injects sections after page load and inline <script> tags inside
   injected HTML never execute. Handles .sb-root sections. */
(function () {
  if (window.__shopBuilderLoaded) return;
  window.__shopBuilderLoaded = true;

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m];
    });
  }
  function money(cents, cur) {
    return cur + (cents / 100).toFixed(2);
  }

  function cfgOf(root) {
    if (root.__sbCfg) return root.__sbCfg;
    var el = root.querySelector('[data-sb-config]');
    if (!el) return null;
    try { root.__sbCfg = JSON.parse(el.textContent); }
    catch (e) { if (window.console) console.error('Shop builder: config could not be read', e); }
    return root.__sbCfg;
  }
  function stateOf(root) {
    if (!root.__sbState) root.__sbState = { cat: 0, prod: 0, col: 0, slide: 0, open: false, cart: null, muted: true };
    return root.__sbState;
  }
  function q(root, sel) { return root.querySelector(sel); }

  function currentProduct(root) {
    var c = cfgOf(root), s = stateOf(root);
    if (!c || !c.cats.length) return null;
    if (s.cat >= c.cats.length) s.cat = 0;
    var cat = c.cats[s.cat];
    if (!cat.products.length) return null;
    if (s.prod >= cat.products.length) s.prod = 0;
    return cat.products[s.prod];
  }

  /* Slides: videos first, then one slide per palette colour (matched photo by
     alt text, else the colour chart), then any unmatched-alt photos. */
  function slidesOf(root) {
    var c = cfgOf(root), pr = currentProduct(root);
    if (!c || !pr) return [];
    var out = [], usedAlts = {};
    pr.media.forEach(function (m) {
      if (m.t === 'vid') out.push({ t: 'vid', src: m.src, poster: m.poster });
    });
    c.colours.forEach(function (col) {
      var match = null;
      pr.media.forEach(function (m) {
        if (!match && m.t === 'img' && m.alt && m.alt.trim().toLowerCase() === col.label.trim().toLowerCase()) match = m;
      });
      if (match) {
        usedAlts[match.alt.trim().toLowerCase()] = true;
        out.push({ t: 'img', src: match.src, cap: col.label, colour: col.label });
      } else {
        out.push({ t: 'chart', colour: col.label });
      }
    });
    pr.media.forEach(function (m) {
      if (m.t !== 'img') return;
      var key = (m.alt || '').trim().toLowerCase();
      if (key && usedAlts[key]) return;
      var isColour = false;
      c.colours.forEach(function (col) { if (key === col.label.trim().toLowerCase()) isColour = true; });
      if (!isColour) out.push({ t: 'img', src: m.src, cap: m.alt || '' });
    });
    return out;
  }

  function slideIndexForColour(root, label) {
    var s = slidesOf(root);
    for (var i = 0; i < s.length; i++) {
      if (s[i].colour && s[i].colour === label) return i;
    }
    return 0;
  }

  /* ---------- rendering ---------- */

  function renderCats(root) {
    var c = cfgOf(root), s = stateOf(root);
    var el = q(root, '[data-sb-cats]');
    if (!el) return;
    el.innerHTML = c.cats.map(function (cat, i) {
      return '<button type="button" class="sb-cat' + (i === s.cat ? ' sb-on' : '') + '" data-sb-cat="' + i + '" role="tab" aria-selected="' + (i === s.cat) + '">' +
        esc(cat.name) + '<span class="sb-count">' + cat.products.length + '</span></button>';
    }).join('');
  }

  function renderChips(root) {
    var c = cfgOf(root), s = stateOf(root);
    var el = q(root, '[data-sb-chips]');
    if (!el) return;
    el.innerHTML = c.cats[s.cat].products.map(function (p, i) {
      return '<button type="button" class="sb-chip' + (i === s.prod ? ' sb-on' : '') + '" data-sb-prod="' + i + '">' + esc(p.title) + '</button>';
    }).join('');
  }

  function renderGallery(root) {
    var c = cfgOf(root), s = stateOf(root);
    var slides = slidesOf(root);
    var gal = q(root, '[data-sb-gal]');
    var sound = q(root, '[data-sb-sound]');
    if (!gal) return;
    if (!slides.length) { gal.innerHTML = ''; if (sound) sound.style.display = 'none'; return; }
    if (s.slide >= slides.length) s.slide = 0;
    var sl = slides[s.slide];

    if (sl.t === 'vid') {
      gal.innerHTML = '<video src="' + esc(sl.src) + '"' + (sl.poster ? ' poster="' + esc(sl.poster) + '"' : '') + ' autoplay muted loop playsinline></video>';
      var v = gal.querySelector('video');
      v.muted = s.muted;
      if (sound) {
        sound.style.display = 'flex';
        sound.textContent = s.muted ? c.soundOn : c.soundOff;
      }
    } else if (sl.t === 'img') {
      gal.innerHTML = '<img src="' + esc(sl.src) + '" alt="' + esc(sl.cap || '') + '" loading="lazy">';
      if (sound) sound.style.display = 'none';
    } else {
      var inner;
      if (c.chart) {
        inner = '<img src="' + esc(c.chart) + '" alt="Colour chart" loading="lazy">';
      } else {
        inner = '<div style="display:grid; grid-template-columns:repeat(3,44px); gap:6px; justify-content:center; padding:34px 0 0;">' +
          c.colours.map(function (col) { return '<span style="width:44px;height:32px;border-radius:5px;background:' + esc(col.hex) + ';"></span>'; }).join('') + '</div>';
      }
      gal.innerHTML = inner + '<div style="height:14px;"></div>';
      if (sound) sound.style.display = 'none';
    }

    var dots = q(root, '[data-sb-dots]');
    if (dots) {
      dots.innerHTML = slides.map(function (x, i) {
        return '<span class="sb-dot' + (i === s.slide ? ' sb-on' : '') + '"></span>';
      }).join('');
    }
  }

  function renderDetail(root) {
    var c = cfgOf(root), s = stateOf(root);
    var pr = currentProduct(root);
    if (!pr) return;
    var nameEl = q(root, '[data-sb-name]'); if (nameEl) nameEl.textContent = pr.title;
    var badge = q(root, '[data-sb-badge]'); if (badge) badge.style.display = pr.fav ? 'inline-block' : 'none';
    var price = q(root, '[data-sb-price]'); if (price) price.textContent = pr.priceF;

    var stars = q(root, '[data-sb-stars]');
    if (stars) {
      if (pr.rating && pr.ratingCount > 0) {
        var pct = Math.max(0, Math.min(100, (pr.rating / 5) * 100));
        stars.style.display = 'flex';
        stars.innerHTML = '<span class="sb-starwrap" aria-hidden="true">\u2605\u2605\u2605\u2605\u2605' +
          '<span class="sb-starfill" style="width:' + pct.toFixed(0) + '%;">\u2605\u2605\u2605\u2605\u2605</span></span>' +
          '<span>' + Number(pr.rating).toFixed(1) + ' (' + pr.ratingCount + ')</span>';
      } else {
        stars.style.display = 'none';
        stars.innerHTML = '';
      }
    }

    var desc = q(root, '[data-sb-desc]');
    var more = q(root, '[data-sb-more]');
    if (desc) {
      desc.innerHTML = pr.desc || '';
      desc.classList.add('sb-clamp');
      if (more) {
        more.style.display = 'none';
        more.textContent = c.readMore;
        setTimeout(function () {
          if (desc.scrollHeight > desc.clientHeight + 6) more.style.display = 'inline-block';
        }, 0);
      }
    }
    if (s.col >= c.colours.length) s.col = 0;
    if (!c.colours[s.col].ok) {
      for (var i = 0; i < c.colours.length; i++) { if (c.colours[i].ok) { s.col = i; break; } }
    }
    var colName = q(root, '[data-sb-colname]'); if (colName) colName.textContent = c.colours.length ? c.colours[s.col].label : '';
    var sw = q(root, '[data-sb-swatches]');
    if (sw) {
      sw.innerHTML = c.colours.map(function (col, i) {
        if (!col.ok) return '<span class="sb-swatch sb-off" title="' + esc(col.label) + ' \u2014 out of stock" style="background:' + esc(col.hex) + ';"></span>';
        return '<button type="button" class="sb-swatch' + (i === s.col ? ' sb-on' : '') + '" data-sb-col="' + i + '" aria-label="' + esc(col.label) + '" style="background:' + esc(col.hex) + ';"></button>';
      }).join('');
    }
    var add = q(root, '[data-sb-add]');
    if (add) {
      add.disabled = pr.sold || !c.colours.some(function (col) { return col.ok; });
      add.textContent = pr.sold ? c.soldOut : c.addText;
    }
    renderGallery(root);
  }

  /* ---------- cart ---------- */

  function refreshCart(root) {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        stateOf(root).cart = cart;
        renderCart(root);
      })
      .catch(function () {});
  }

  function renderCart(root) {
    var c = cfgOf(root), s = stateOf(root);
    var cart = s.cart;
    var n = cart ? cart.item_count : 0;
    var total = cart ? cart.total_price : 0;

    var summary = q(root, '[data-sb-cartsummary]');
    if (summary) summary.textContent = n === 0 ? c.cartEmpty : c.cartWord + ' \u00b7 ' + n + ' item' + (n === 1 ? '' : 's');
    var totalEl = q(root, '[data-sb-total]');
    if (totalEl) totalEl.textContent = n === 0 ? '' : money(total, c.currency);
    var co = q(root, '[data-sb-checkout]');
    if (co) co.disabled = n === 0;

    var ship = q(root, '[data-sb-ship]');
    if (ship) {
      if (n === 0) {
        ship.classList.remove('sb-done');
        ship.textContent = c.freeBase.replace('{threshold}', money(c.freeThreshold, c.currency));
      } else if (total >= c.freeThreshold) {
        ship.classList.add('sb-done');
        ship.textContent = c.freeDone;
      } else {
        ship.classList.remove('sb-done');
        ship.textContent = c.freeProgress.replace('{amount}', money(c.freeThreshold - total, c.currency));
      }
    }

    var chev = q(root, '[data-sb-cartchev]');
    if (chev) chev.innerHTML = s.open ? '&#9660;' : '&#9650;';

    var lines = q(root, '[data-sb-lines]');
    if (lines) {
      lines.style.display = (s.open && n > 0) ? 'block' : 'none';
      if (cart && n > 0) {
        lines.innerHTML = cart.items.map(function (it) {
          var colour = (it.properties && it.properties[c.colourProperty]) || '';
          var hex = '#888780';
          cfgOf(root).colours.forEach(function (col) { if (col.label === colour) hex = col.hex; });
          return '<div class="sb-line">' +
            '<span class="sb-lchip" style="background:' + esc(hex) + ';"></span>' +
            '<span class="sb-lname">' + esc(it.product_title) + (colour ? ' \u00b7 ' + esc(colour) : '') + '</span>' +
            '<button type="button" class="sb-qbtn" data-sb-dec="' + esc(it.key) + '" data-sb-q="' + it.quantity + '" aria-label="Decrease quantity">&#8722;</button>' +
            '<span class="sb-lqty">' + it.quantity + '</span>' +
            '<button type="button" class="sb-qbtn" data-sb-inc="' + esc(it.key) + '" data-sb-q="' + it.quantity + '" aria-label="Increase quantity">+</button>' +
            '<span class="sb-lprice">' + money(it.final_line_price, c.currency) + '</span>' +
            '</div>';
        }).join('');
      } else {
        lines.innerHTML = '';
      }
    }
  }

  function changeLine(root, key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { stateOf(root).cart = cart; renderCart(root); })
      .catch(function () { refreshCart(root); });
  }

  function addToCart(root) {
    var c = cfgOf(root), s = stateOf(root);
    var pr = currentProduct(root);
    if (!pr || pr.sold) return;
    var col = c.colours[s.col];
    if (!col || !col.ok) return;
    var props = {};
    props[c.colourProperty] = col.label;
    var btn = q(root, '[data-sb-add]');
    if (btn) btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: pr.id, quantity: 1, properties: props })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        s.open = true;
        refreshCart(root);
        var note = q(root, '[data-sb-added]');
        if (note) {
          note.style.visibility = 'visible';
          setTimeout(function () { note.style.visibility = 'hidden'; }, 1500);
        }
      })
      .catch(function () { refreshCart(root); })
      .then(function () {
        var pr2 = currentProduct(root);
        if (btn) { btn.disabled = pr2 ? pr2.sold : false; }
      });
  }

  function renderAll(root) {
    renderCats(root);
    renderChips(root);
    renderDetail(root);
    renderCart(root);
  }

  /* ---------- init + events ---------- */

  function initAll() {
    var roots = document.querySelectorAll('.sb-root');
    for (var i = 0; i < roots.length; i++) {
      if (!roots[i].__sbDone) {
        roots[i].__sbDone = true;
        if (cfgOf(roots[i])) {
          renderAll(roots[i]);
          refreshCart(roots[i]);
        }
      }
    }
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var el, root;

    if ((el = t.closest('.sb-root [data-sb-cat]'))) {
      root = el.closest('.sb-root');
      var s = stateOf(root);
      s.cat = Number(el.getAttribute('data-sb-cat')); s.prod = 0; s.slide = 0;
      renderCats(root); renderChips(root); renderDetail(root);
      return;
    }
    if ((el = t.closest('.sb-root [data-sb-prod]'))) {
      root = el.closest('.sb-root');
      var s2 = stateOf(root);
      s2.prod = Number(el.getAttribute('data-sb-prod')); s2.slide = 0;
      renderChips(root); renderDetail(root);
      return;
    }
    if ((el = t.closest('.sb-root [data-sb-col]'))) {
      root = el.closest('.sb-root');
      var s3 = stateOf(root);
      s3.col = Number(el.getAttribute('data-sb-col'));
      var c3 = cfgOf(root);
      s3.slide = slideIndexForColour(root, c3.colours[s3.col].label);
      renderDetail(root);
      return;
    }
    if ((el = t.closest('.sb-root [data-sb-prev]'))) {
      root = el.closest('.sb-root');
      var s4 = stateOf(root), n4 = slidesOf(root).length;
      if (n4) { s4.slide = (s4.slide - 1 + n4) % n4; renderGallery(root); }
      return;
    }
    if ((el = t.closest('.sb-root [data-sb-next]'))) {
      root = el.closest('.sb-root');
      var s5 = stateOf(root), n5 = slidesOf(root).length;
      if (n5) { s5.slide = (s5.slide + 1) % n5; renderGallery(root); }
      return;
    }
    if ((el = t.closest('.sb-root [data-sb-sound]'))) {
      root = el.closest('.sb-root');
      var s6 = stateOf(root), c6 = cfgOf(root);
      s6.muted = !s6.muted;
      var v = root.querySelector('[data-sb-gal] video');
      if (v) v.muted = s6.muted;
      el.textContent = s6.muted ? c6.soundOn : c6.soundOff;
      return;
    }
    if ((el = t.closest('.sb-root [data-sb-more]'))) {
      root = el.closest('.sb-root');
      var c8 = cfgOf(root);
      var d8 = q(root, '[data-sb-desc]');
      if (d8) {
        var clamped = d8.classList.toggle('sb-clamp') === false;
        el.textContent = clamped ? c8.readLess : c8.readMore;
      }
      return;
    }
    if ((el = t.closest('.sb-root [data-sb-add]'))) {
      addToCart(el.closest('.sb-root'));
      return;
    }
    if ((el = t.closest('.sb-root [data-sb-carttoggle]'))) {
      root = el.closest('.sb-root');
      var s7 = stateOf(root);
      s7.open = !s7.open;
      renderCart(root);
      return;
    }
    if ((el = t.closest('.sb-root [data-sb-inc]'))) {
      root = el.closest('.sb-root');
      changeLine(root, el.getAttribute('data-sb-inc'), Number(el.getAttribute('data-sb-q')) + 1);
      return;
    }
    if ((el = t.closest('.sb-root [data-sb-dec]'))) {
      root = el.closest('.sb-root');
      changeLine(root, el.getAttribute('data-sb-dec'), Number(el.getAttribute('data-sb-q')) - 1);
      return;
    }
    if ((el = t.closest('.sb-root [data-sb-checkout]')) && !el.disabled) {
      window.location.href = '/checkout';
      return;
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  window.addEventListener('load', initAll);
  document.addEventListener('shopify:section:load', initAll);

  function watch() {
    if (!document.body) return;
    new MutationObserver(initAll).observe(document.body, { childList: true, subtree: true });
  }
  if (document.body) watch();
  else document.addEventListener('DOMContentLoaded', watch);
})();